export default __webpack_public_path__ + "static/media/comercio.5edc5cf1.mp3";